import React, { useState } from "react";
import Tabs from "./Tabs";
import SlideKickPlayers from "./slideKickPlayers";

export default (props) => {
  const [show_slidekick_players, set_show_slidekick_players] = useState(false);
  if (show_slidekick_players) {
    return <SlideKickPlayers onBack={props.onBack} />;
  } else {
    return (
      <Tabs
        onBack={props.onBack}
        set_show_slidekick_players={set_show_slidekick_players}
      ></Tabs>
    );
  }
};
